/**
 * Référentiel des communes (`District`), pour la liste déroulante « commune »
 * obligatoire du tunnel de commande (VVS_MODELE_INTERFACE.md §8.2 : « Commune
 * en liste déroulante obligatoire, jamais en texte libre — c'est elle qui
 * calcule les frais »).
 *
 * Porté depuis apps/web/lib/shipping-districts.ts, adapté au runtime
 * navigateur : plus de `process.env.INTERNAL_API_URL` (accès serveur-à-
 * serveur au réseau Docker interne, inapplicable depuis ce SPA) ni de
 * `next: { revalidate, tags }` (hint de cache ISR propre au `fetch()` serveur
 * Next.js, absent du `fetch()` du DOM) — chemin relatif fixe
 * `/api/v1/shipping/districts`, comme le reste de ce SPA (cf.
 * src/lib/api-client.ts), proxyé par Vite en dev / nginx en prod.
 *
 * Volontairement gardé séparé de src/lib/api-client.ts plutôt que d'y être
 * ajouté, comme l'original (même raison : ce fichier n'appartient pas au même
 * lot que le panier/devis/commande porté ligne à ligne dans api-client.ts,
 * pour limiter le risque de collision d'édition avec les autres ateliers).
 */

const API_PREFIX = "/api/v1";

/** Forme exacte de `DistrictOption` (apps/api/src/shipping/shipping.service.ts). */
export interface ShippingDistrict {
  id: string;
  name: string;
  citySlug: string;
  cityName: string;
  regionName: string;
}

export async function getShippingDistricts(): Promise<ShippingDistrict[]> {
  const res = await fetch(`${API_PREFIX}/shipping/districts`, {
    method: "GET",
    headers: { Accept: "application/json" },
    credentials: "include",
  });

  if (!res.ok) {
    throw new Error(`Échec de la requête API VVS : GET /shipping/districts (HTTP ${res.status})`);
  }

  const body = (await res.json()) as { items: ShippingDistrict[] };
  return body.items;
}
